import React from 'react';
import { useCachedFile } from '~/hooks/useCachedFile';

function Image({ src, alt, transformation, ...props }) {
  const { cachedUrl, loading } = useCachedFile(src, transformation);

  return <img src={cachedUrl || src} alt={alt} {...props} />;
}

export default Image;
